import { MoonIcon, SunIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";

import { useTheme } from "../context/ThemeContext";

/** Cool Mist / Midnight Navy toggle. Sits beside the language switcher. */
export default function ThemeSwitcher({ compact = false }) {
  const { theme, toggleTheme } = useTheme();
  const { t } = useTranslation();
  const label = theme === "dark" ? t("app.lightMode") : t("app.darkMode");
  const Icon = theme === "dark" ? SunIcon : MoonIcon;

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={label}
      title={label}
      className={`flex items-center justify-center gap-2 rounded-md border border-line-strong font-semibold
        text-ink transition-colors duration-fast hover:bg-raised ${
          compact ? "min-h-touch w-10 px-2 py-1 text-xs" : "min-h-touch w-full px-3 py-2 text-sm"
        }`}
    >
      <Icon className="h-4 w-4 stroke-2" />
      {!compact && <span>{label}</span>}
    </button>
  );
}
